import { render, staticRenderFns } from "./QualifikationModal.vue?vue&type=template&id=47b8833c&"
import script from "./QualifikationModal.vue?vue&type=script&lang=js&"
export * from "./QualifikationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports